"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextFilter_1 = __importDefault(require("./TextFilter"));
var CustomFilter = function (_a) {
    /*
    if (filter.type === 'checkbox') {
      return <CheckboxFilter filter={filter} />;
    }
  
    if (filter.type === 'dropdown') {
      return <DropdownFilter filter={filter} />;
    }
  
    if (filter.type === 'date') {
      return <DateFilter filter={filter} />;
    }*/
    var filter = _a.filter;
    if (filter.type === 'text') {
        return react_1.default.createElement(TextFilter_1.default, { filter: filter });
    }
    return null;
};
exports.default = CustomFilter;
